export default __webpack_public_path__ + "static/media/2high-frog.7eac8ff1.jpeg";